/* Shared formatters for every measurement in the system. */
const MONTHS = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];

/** ISO date or Date -> "28 Aug 2026". Passes through strings already in that shape. */
export function formatMeasuredOn(input) {
  if (!input) return null;
  if (input instanceof Date) return fmt(input);
  const s = String(input);
  if (/^\d{4}-\d{2}-\d{2}/.test(s)) {
    const [y, m, d] = s.slice(0, 10).split('-').map(Number);
    return fmt(new Date(Date.UTC(y, m - 1, d)));
  }
  return s;
}
function fmt(d) {
  return d.getUTCDate() + ' ' + MONTHS[d.getUTCMonth()] + ' ' + d.getUTCFullYear();
}

/** Tabular integer/decimal formatting; never rounds a denominator away. */
export function formatCount(n) {
  if (n == null || Number.isNaN(n)) return null;
  return typeof n === 'number' ? n.toLocaleString('en-US') : String(n);
}
